export default __webpack_public_path__ + "static/media/bt.cf61bcae.svg";